import { render, staticRenderFns } from "./listReports.vue?vue&type=template&id=634e72a7"
import script from "./listReports.vue?vue&type=script&lang=js"
export * from "./listReports.vue?vue&type=script&lang=js"
import style0 from "./listReports.vue?vue&type=style&index=0&id=634e72a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports